import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DatePicker } from "@mui/x-date-pickers";
import BaseCadastro from "components/BaseCadastro";
import { useToastContext } from "components/alert/ToastContext";
import AnexoPanel, { getFormData } from "components/anexo/AnexoPanel";
import InputMonetario from "components/input/InputMonetario";
import { Label } from "components/input/Label";
import ModalDespesaVerArquivos from "components/modal/viagem/ModalDespesaVerArquivos";
import ModalViagemDespesaEditar from "components/modal/viagem/ModalViagemDespesaEditar";
import ModalViagemDespesaPrevistaEditar from "components/modal/viagem/ModalViagemDespesaPrevistaEditar";
import ReportEdit from "components/reports/ReportEdit";
import dayjs from "dayjs";
import saveAs from 'file-saver';
import { BaseModel } from "model/BaseModel";
import Usuario from "model/administracao/cadastro/Usuario";
import CentroCusto from "model/administracao/cadastro/centrocusto/CentroCusto";
import Viagem from "model/viagem/Viagem";
import ViagemAprovacao from "model/viagem/ViagemAprovacao";
import ViagemDespesa from "model/viagem/ViagemDespesa";
import ViagemDespesaPrevista from "model/viagem/ViagemDespesaPrevista";
import ViagemTipoDespesa from "model/viagem/ViagemTipoDespesa";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { SplitButton } from "primereact/splitbutton";
import { TabPanel, TabView } from "primereact/tabview";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import "react-hook-form";
import { Controller, useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import ContaParametroService from "service/administracao/cadastro/ContaParametroService";
import UsuarioLogadoService from "service/usuario/UsuarioLogadoService";
import ViagemAprovacaoService from "service/viagem/ViagemAprovacaoService";
import ViagemDespesaPrevistaService from "service/viagem/ViagemDespesaPrevistaService";
import ViagemDespesaService from "service/viagem/ViagemDespesaService";
import ViagemService from "service/viagem/ViagemService";
import { converterData, converterDataHora } from "utils/convert";

const viagemService = new ViagemService();
const viagemAprovacaoService = new ViagemAprovacaoService();
const viagemDespesaPrevistaService = new ViagemDespesaPrevistaService();
const viagemDespesaService = new ViagemDespesaService();
const usuarioLogadoService = new UsuarioLogadoService();
const contaParametroService = new ContaParametroService();
export default function ViagemCadastro() {

    const [queryParameters] = useSearchParams();

    const [viagem, setViagem] = useState<Viagem>(new Viagem());
    const [titulo, setTitulo] = useState<string>('Minhas Viagens');
    const [dialogImagens, setDialogImagens] = useState<{ visible: boolean, despesa: ViagemDespesa, index: number }>({ visible: false, despesa: new ViagemDespesa(), index: 0 });
    const [dialogImagensDespesaPrevista, setDialogImagensDespesaPrevista] = useState<{ visible: boolean, despesaPrevista: ViagemDespesaPrevista, index: number }>({ visible: false, despesaPrevista: new ViagemDespesaPrevista(), index: 0 });
    const [dialogDespesaPrevista, setDialogDespesaPrevista] = useState<{ visible: boolean, despesa: ViagemDespesaPrevista }>({ visible: false, despesa: new ViagemDespesaPrevista() });
    const [dialogDespesa, setDialogDespesa] = useState<{ visible: boolean, despesa: ViagemDespesa }>({ visible: false, despesa: new ViagemDespesa() });
    const [centrosCustoDisponiveis, setCentrosCustoDisponiveis] = useState<CentroCusto[]>([]);
    const [insereOutrosUsuarios, setInsereOutrosUsuarios] = useState<boolean>(false);
    const [editando, setEditando] = useState<boolean>(false);
    const [abaAtiva, setAbaAtiva] = useState(0);
    const [usuarios, setUsuarios] = useState<Usuario[]>([]);
    const [visibleDialogRelatorios, setVisibleDialogRelatorios] = useState(false);
    const [editaRelatorios, setEditaRelatorios] = useState(false);
    const [excluiDespesas, setExcluiDespesas] = useState(false);
    const [adiantamentoIgualDespesaPrevista, setAdiantamentoIgualDespesaPrevista] = useState(false);
    const [expandedRowsDespesas, setExpandedRowsDespesas] = useState<any>([]);

    const [aprovacoesAgrupadas, setAprovacoesAgrupadas] = useState<{ sequencial: number, aprovacoes: ViagemAprovacao[] }[]>([]);

    const { startLoading, stopLoading } = useLoadingContext();
    const { msgSucesso, msgErro, msgAlerta } = useToastContext();
    const { setError, formState: { errors }, register, clearErrors, control } = useForm();
    const navigate = useNavigate();

    useEffect(() => {
        usuarioLogadoService.getAcoesUsuarioLogado().then((resposta) => {
            if (usuarioLogadoService.usuarioTemAcao(resposta, "VIAGEM_INCLUIR_PARA_OUTRO_USUARIO")) {
                setInsereOutrosUsuarios(true);
            }
            if (usuarioLogadoService.usuarioTemAcao(resposta, "RELATORIO_VIAGEM_SOLICITACAO_EDITAR")) {
                setEditaRelatorios(true);
            }
            if (usuarioLogadoService.usuarioTemAcao(resposta, "VIAGEM_DESPESA_EXCLUIR")) {
                setExcluiDespesas(true);
            }
        }).catch((erro) => {
            console.log(erro);
        });
        contaParametroService.buscarParametro("VIAGENS_ADIANTAMENTO_IGUAL_AS_DESPESAS_PREVISTAS").then((parametro) => {
            if (parametro && parametro.valorBooleano) {
                setAdiantamentoIgualDespesaPrevista(true);
            }
        }).catch((err) => {
            console.error(err);
        });
        viagemService.getCentroCustoDisponiveis().then((response) => {
            setCentrosCustoDisponiveis(response)
        }).catch(err => {
            console.error(err);
        });
        viagemService.getUsuariosDisponiveis().then((response) => {
            setUsuarios(response);
        }).catch(err => {
            console.log(err);
        })
    }, []);

    useEffect(() => {
        if (window.location.pathname !== ('/viagem/cadastrar')) {
            setEditando(true);
            consultar();
        } else {
            contaParametroService.buscarParametro("VIAGENS_CUSTO_COMBUSTIVEL_POR_QUILOMETRO").then((parametro) => {
                if (parametro && parametro.valorNumerico) {
                    let viagemLocal = { ...viagem };
                    viagemLocal.custoPorQuilometro = parametro.valorNumerico;
                    setViagem(viagemLocal);
                }
            }).catch((err) => {
                console.error(err);
            });
        }

    }, []);

    useEffect(() => {
        if (adiantamentoIgualDespesaPrevista && viagemDespesaPrevistaService.podeAlterar(viagem.situacao)) {
            recalcularAdiantamentoDespesaPrevista();
        }
    }, [adiantamentoIgualDespesaPrevista, viagem.despesasPrevistas]);

    function recalcularAdiantamentoDespesaPrevista() {
        let viagemLocal = { ...viagem };
        const totalDespesasPrevistas = viagemLocal.despesasPrevistas.reduce((acc, item) => acc + item.valor, 0);
        viagemLocal.valorAdiantamento = totalDespesasPrevistas;
        setViagem(viagemLocal);
    }

    function validar() {
        if (insereOutrosUsuarios && viagem.usuarioSolicitante == null) {
            setError("usuarioSolicitante", { type: "manual", message: "Solicitante é Obrigatório" }, { shouldFocus: true });
            return false;
        }
        if (viagem.dataPartida === null) {
            setError("dataPartida", { type: "manual", message: "Data de Partida é Obrigatória" }, { shouldFocus: true });
            return false;
        }
        if (viagem.dataRetorno === null) {
            setError("dataRetorno", { type: "manual", message: "Data de Retorno é Obrigatória" }, { shouldFocus: true });
            return false;
        }
        if (viagem.dataPartida > viagem.dataRetorno) {
            setError("dataRetorno", { type: "manual", message: "Data de Retorno deve ser maior ou igual a Data de Partida" }, { shouldFocus: true });
            return false;
        }
        if (viagem.centroCusto === null) {
            setError("centroCusto", { type: "manual", message: "Centro de Custo é Obrigatório" }, { shouldFocus: true });
            return false;
        }
        if (viagem.itinerario === "") {
            setError("itinerario", { type: "manual", message: "Itinerario é Obrigatório" }, { shouldFocus: true });
            return false;
        }
        if (viagem.motivoViagem === "") {
            setError("motivoViagem", { type: "manual", message: "Motivo da Viagem é Obrigatório" }, { shouldFocus: true });
            return false;
        }
        if (viagem.tipoLocomocao === "") {
            setError("tipoLocomocao", { type: "manual", message: "Tipo de Locomoção é Obrigatório" }, { shouldFocus: true });
            return false;
        }
        return true;
    }

    const consultar = () => {
        startLoading();
        viagemService.consultar(window.location.pathname.substring(`/viagem/editar/`.length))
            .then((data: Viagem) => {
                setViagem(data);
                const aprovacoesAgrupadasLocal: { sequencial: number, aprovacoes: ViagemAprovacao[] }[] = [];
                data.aprovacoes.forEach(aprovacao => {
                    let agrupamento = aprovacoesAgrupadasLocal.find(agrupamento => agrupamento.sequencial === aprovacao.sequencial);
                    if (!agrupamento) {
                        agrupamento = { sequencial: aprovacao.sequencial, aprovacoes: [aprovacao] };
                        aprovacoesAgrupadasLocal.push(agrupamento);
                    } else {
                        agrupamento.aprovacoes.push(aprovacao);
                    }
                });
                aprovacoesAgrupadasLocal.sort((a, b) => a.sequencial - b.sequencial);
                setAprovacoesAgrupadas(aprovacoesAgrupadasLocal);
            }).catch(error => {
                console.error(error);
                if (error && error.data && error.data.message) {
                    msgErro(titulo, error.data.message);
                } else {
                    msgErro(titulo, 'Ocorreu um erro ao tentar carregar, tente novamente!');
                }
            }).finally(() => {
                stopLoading();
            });
    }

    const gravar = (viagem: Viagem) => {
        startLoading();
        if (viagem.usuarioSolicitante != null && viagem.usuarioSolicitante.id != usuarioLogadoService.getUsuario().id) {
            salvarOutroUsuario(viagem);
        } else {
            salvar(viagem);
        }
    }

    const salvar = (viagem: Viagem) => {
        viagemService.salvar(viagem).then((response) => {
            msgSucesso(titulo, 'Registro gravado com sucesso');
            if (!editando) {
                navigate(`/viagem/editar/${response.id}`);
            }
            consultar();
        }).catch((err) => {
            console.error(err);
            if (err && err.data && err.data.message) {
                msgErro(titulo, err.data.message);
            } else {
                msgErro(titulo, 'Ocorreu um erro ao tentar gravar, tente novamente!');
            }
        }).finally(() => {
            stopLoading();
        })
    }

    const salvarOutroUsuario = (viagem: Viagem) => {
        viagemService.salvarOutroUsuario(viagem).then((response) => {
            msgSucesso(titulo, 'Registro gravado com sucesso');
            if (!editando) {
                navigate(`/viagem/editar/${response.id}`);
            }
            consultar();
        }).catch((err) => {
            console.error(err);
            if (err && err.data && err.data.message) {
                msgErro(titulo, err.data.message);
            } else {
                msgErro(titulo, 'Ocorreu um erro ao tentar gravar, tente novamente!');
            }
        }).finally(() => {
            stopLoading();
        })
    }

    const salvarEnviarAprovacao = (viagem: Viagem) => {
        startLoading();
        viagemService.salvarEnviarAprovacao(viagem).then((response) => {
            msgSucesso(titulo, 'Registro gravado com sucesso');
            if (!editando) {
                navigate(`/viagem/editar/${response.id}`);
            }
            consultar();
        }).catch((err) => {
            console.error(err);
            if (err && err.data && err.data.message) {
                msgErro(titulo, err.data.message);
            } else {
                msgErro(titulo, 'Ocorreu um erro ao tentar gravar, tente novamente!');
            }
        }).finally(() => {
            stopLoading();
        })
    }

    const cancelar = (viagem: Viagem) => {
        startLoading();
        viagemService.cancelar(viagem).then((response) => {
            msgSucesso(titulo, 'Registro cancelado com sucesso');
            consultar();
        }).catch((err) => {
            console.error(err);
            if (err && err.data && err.data.message) {
                msgErro(titulo, err.data.message);
            } else {
                msgErro(titulo, 'Ocorreu um erro ao tentar gravar, tente novamente!');
            }
        }).finally(() => {
            stopLoading();
        })
    }

    const finalizar = (viagem: Viagem) => {
        startLoading();
        viagemService.finalizar(viagem).then((response) => {
            msgSucesso(titulo, 'Registro finalizado com sucesso');
            consultar();
        }).catch((err) => {
            console.error(err);
            if (err && err.data && err.data.message) {
                msgErro(titulo, err.data.message);
            } else {
                msgErro(titulo, 'Ocorreu um erro ao tentar gravar, tente novamente!');
            }
        }).finally(() => {
            stopLoading();
        })
    }

    const reabrir = () => {
        startLoading();
        viagemService.reabrir(viagem.id).then((response) => {
            msgSucesso(titulo, 'Viagem reaberta com sucesso');
            consultar();
        }).catch((err) => {
            console.error(err);
            if (err && err.data && err.data.message) {
                msgErro(titulo, err.data.message);
            } else {
                msgErro(titulo, 'Ocorreu um erro ao tentar gravar, tente novamente!');
            }
        }).finally(() => {
            stopLoading();
        })
    }



    function gerarRelatorioViagemSolicitacao(id: number) {
        startLoading();
        viagemService.getRelatorioViagemSolicitacao(id).then(data => {
            stopLoading();
            const file = new Blob([data], { type: 'application/pdf' });
            saveAs(file, `ViagemSolicitacao.pdf`);
        }).catch(err => {
            stopLoading();
            msgErro("Erro ao gerar Relatório", err.message);
            console.log(err);
        });
    }

    const botoesExtra = <>
        {viagem.id ? (editaRelatorios ? (
            <SplitButton
                onClick={() => gerarRelatorioViagemSolicitacao(viagem.id)}
                label="Relat. Viagem Solicitação" style={{ width: 250, marginLeft: 8 }}
                model={[
                    { label: 'Editar relatório', command: () => { setVisibleDialogRelatorios(true) } }
                ]}

            />
        ) :
            <Button onClick={() => gerarRelatorioViagemSolicitacao(viagem.id)} label="Relat. Viagem Solicitação" style={{ width: 200, marginLeft: 8 }} />
        ) : null}
        {(viagem.situacao == 'ABERTA' || viagem.situacao == 'ENVIADA_APROVACAO') && (abaAtiva == 0) ? <Button label="Salvar"
            onClick={() => {
                if (validar()) {
                    gravar(viagem)
                }
            }} style={{ marginLeft: 8 }} /> : null}
        {viagem.id && viagem.situacao == 'ABERTA' || viagem.situacao == 'REJEITADA' && (abaAtiva == 0) ? <Button label="Salvar e Enviar para Aprovação" onClick={() => salvarEnviarAprovacao(viagem)} style={{ marginLeft: 8 }} /> : null}
        {viagem.id && viagem.situacao != 'FINALIZADA' && viagem.situacao != 'CANCELADA' && (abaAtiva == 0) ? <Button label="Cancelar" onClick={() => cancelar(viagem)} style={{ marginLeft: 8 }} /> : null}
        {viagem.id && viagem.situacao == 'APROVADA' && (abaAtiva == 0) ? <Button label="Finalizar" onClick={() => finalizar(viagem)} style={{ marginLeft: 8 }} /> : null}
        {viagem.id && viagem.situacao == 'FINALIZADA' && (abaAtiva == 0) ? <Button label="Reabrir" onClick={() => reabrir()} style={{ marginLeft: 8 }} /> : null}

    </>

    const headerDespesaPrevista =
        <div style={{ display: "flex", justifyContent: "space-between", textAlign: 'center', alignContent: "center" }}>
            <div></div>
            <span style={{ textAlign: 'center', alignSelf: "center", position: 'relative' }}>Despesas Previstas</span>
            <div>
                {viagem.id && viagemDespesaPrevistaService.podeAlterar(viagem.situacao) ? <Button
                    type="button" icon={<FontAwesomeIcon icon="add" />}
                    tooltip="Adicionar"
                    tooltipOptions={{ position: "top" }} className="ui-button-info" onClick={() => setDialogDespesaPrevista({ visible: true, despesa: new ViagemDespesaPrevista(null, viagem) })}
                ></Button> : null}
            </div>
        </div>

    const footerDespesasPrevistas = () => {
        return (
            <div style={{ display: "flex", justifyContent: "space-between", textAlign: 'right', alignContent: "center" }}>
                <div></div>
                <div>
                    <span style={{ textAlign: 'center', alignSelf: "center", position: 'relative' }}><strong>{"Total: R$ " + viagem.despesasPrevistas.reduce((acc, item) => acc + item.valor, 0).toFixed(2).replace(".", ",")}</strong></span>
                </div>
            </div>
        )
    }

    function removerDespesaPrevista(item: BaseModel) {

        confirmDialog({
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            message: 'Deseja realmente excluir este registro?',
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            accept: () => removerDespesaPrevistaConfirm(item),
        });


    }

    function removerDespesaPrevistaConfirm(item: BaseModel) {

        let identificador = item.id;
        if (identificador) {
            viagemDespesaPrevistaService.excluir(identificador)
                .then(() => {
                    msgSucesso("Despesa Prevista", 'Despesa Prevista removida com sucesso!');
                    consultar();
                })
                .catch(error => {
                    console.error(error);
                    if (error && error.data && error.data.message) {
                        msgErro("Despesa", error.data.message);
                    } else {
                        msgErro("Despesa", 'Ocorreu um erro ao tentar remover a Despesa, tente novamente!');
                    }

                });
        }

    }

    const rowExpansionTemplateDespesas = (data: ViagemDespesa) => {
        return <DataTable value={data.aprovacoes} size="small" header="Aprovações">
            <Column field="usuario.nome" header="Aprovador" />
            <Column field="situacao" header="Situação" body={(rowData) => viagemDespesaService.getSituacaoAprovacao(rowData.situacao)} />
            <Column field="dataAprovacao" header="Data aprovação" body={(rowData) => converterDataHora(rowData.dataAprovacao)} />
        </DataTable>
    }

    const headerDespesa =
        <div style={{ display: "flex", justifyContent: "space-between", textAlign: 'center', alignContent: "center" }}>
            <div></div>
            <span style={{ textAlign: 'center', alignSelf: "center", position: 'relative' }}>{"Despesas"}</span>
            <div>
                <Button
                    type="button" icon={<FontAwesomeIcon icon="add" />}
                    tooltip="Adicionar"
                    disabled={viagem.situacao != "APROVADA"}
                    tooltipOptions={{ position: "top" }} className="ui-button-info" onClick={() => setDialogDespesa({ visible: true, despesa: new ViagemDespesa(null, null, viagem) })}
                ></Button>
            </div>
        </div>

    const footerDespesas = () => {
        return (
            <div style={{ display: "flex", justifyContent: "space-between", textAlign: 'right', alignContent: "center" }}>
                <div></div>
                <div>
                    <span style={{ textAlign: 'center', alignSelf: "center", position: 'relative' }}><strong>{"Total: R$ " + viagem.despesas.reduce((acc, item) => acc + item.valor, 0).toFixed(2).replace(".", ",")}</strong></span>
                </div>
            </div>
        )
    }

    function removerDespesa(item: BaseModel) {

        confirmDialog({
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            message: 'Deseja realmente excluir este registro?',
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            accept: () => removerDespesaConfirm(item),
        });

    }

    function removerDespesaConfirm(item: BaseModel) {

        if (item.id) {
            viagemDespesaService.excluir(item.id)
                .then(() => {
                    msgSucesso("Despesa", 'Despesa removida com sucesso!');
                    consultar();
                })
                .catch(error => {
                    console.error(error);
                    if (error && error.data && error.data.message) {
                        msgErro("Despesa", error.data.message);
                    } else {
                        msgErro("Despesa", 'Ocorreu um erro ao tentar remover a Despesa, tente novamente!');
                    }

                });
        }

    }

    return (
        <>
            <Dialog visible={visibleDialogRelatorios}
                onHide={() => setVisibleDialogRelatorios(false)}
                header="Relatórios"
                style={{ width: "50%" }}
            >
                <ReportEdit nomeAcao="RELATORIO_VIAGEM_SOLICITACAO_EDITAR" titulo="Relatório Viagem" testarRelatorio={() => { }} style={{ marginBottom: 10 }} />
            </Dialog>
            <BaseCadastro model={viagem} service={viagemService} setModel={(value: Viagem) => setViagem(value)} showGravarButton={false} botoesExtra={botoesExtra}
                validar={() => validar()} urlService="/viagem" pathCadastro="/viagem" tituloPagina={titulo} setModelEditando={(value: boolean) => setEditando(value)}
                duplicar={true} fieldsToExcludeOnDuplicate={["situacao", "usuarioSolicitante", "aprovacoes", "despesas", "despesasPrevistas"]} getNewModel={() => new Viagem}>

                {titulo ?
                    <div className="row">
                        <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                    </div>
                    : null}

                {dialogImagens.visible ? <ModalDespesaVerArquivos
                    arquivos={dialogImagens.despesa.imagens}
                    visible={dialogImagens.visible}
                    onHide={() => setDialogImagens({ visible: false, despesa: new ViagemDespesa(), index: 0 })} />
                    : null}
                {dialogImagensDespesaPrevista.visible ? <ModalDespesaVerArquivos
                    arquivos={dialogImagensDespesaPrevista.despesaPrevista.imagens}
                    visible={dialogImagensDespesaPrevista.visible}
                    onHide={() => setDialogImagensDespesaPrevista({ visible: false, despesaPrevista: new ViagemDespesaPrevista(), index: 0 })} /> : null}
                {dialogDespesaPrevista.visible ? <ModalViagemDespesaPrevistaEditar
                    visible={dialogDespesaPrevista.visible}
                    viagemDespesaPrevista={dialogDespesaPrevista.despesa}
                    onHide={() => {
                        setDialogDespesaPrevista({ visible: false, despesa: new ViagemDespesaPrevista() })
                        consultar();
                    }}
                /> : null}
                {dialogDespesa.visible ? <ModalViagemDespesaEditar
                    viagemDespesa={dialogDespesa.despesa}
                    visible={dialogDespesa.visible}
                    onHide={() => {
                        setDialogDespesa({ visible: false, despesa: new ViagemDespesa() })
                        consultar();
                    }} /> : null}

                <TabView activeIndex={abaAtiva} onTabChange={(e) => { setAbaAtiva(e.index) }}>
                    <TabPanel header="Geral">
                        <div className="row">
                            <Label className="col col-sm-12">Código</Label>
                            <div className="col-sm-12">
                                <InputText
                                    required value={viagem.codigo || ""}
                                    style={{ width: '30%' }}
                                />
                            </div>
                        </div>

                        <div className="row">
                            <Label className="col col-sm-12">Situação</Label>
                            <div className="col-sm-12">
                                <InputText
                                    required value={viagemService.getSituacao(viagem.situacao)}
                                    style={{ width: '30%' }}
                                />
                            </div>
                        </div>

                        {insereOutrosUsuarios ? null : <div className="row">
                            <Label className="col col-sm-12">Solicitante</Label>
                            <div className="col-sm-12">
                                <InputText
                                    required value={viagem.usuarioSolicitante?.nome || ""}
                                    style={{ width: '30%' }}
                                />
                            </div>
                        </div>}

                        {insereOutrosUsuarios ? <div className="row">
                            <Label className="col col-sm-12" obrigatorio>Solicitante</Label>
                            <div className="col-sm-12">
                                <Controller name="usuarioSolicitante" control={control} render={({ field }) => (
                                    <Dropdown
                                        inputRef={field.ref}
                                        onChange={(e) => {
                                            setViagem({ ...viagem, usuarioSolicitante: e.target.value });
                                            clearErrors("usuarioSolicitante");
                                        }}
                                        value={viagem.usuarioSolicitante || ""}
                                        disabled={viagem.situacao != "ABERTA"}
                                        optionLabel="nome"
                                        dataKey="id"
                                        filter
                                        options={usuarios}
                                        style={{ width: '25%' }}
                                    />
                                )} />
                            </div>
                            {errors.usuarioSolicitante && errors.usuarioSolicitante.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.usuarioSolicitante?.message as string}</span> : null}
                        </div> : null}

                        <div className="row">
                            <Label className="col col-sm-12">Data solicitação</Label>
                            <div className="col-sm-12">
                                <InputText
                                    required value={converterData(viagem.dataSolicitacao) || ""}
                                    style={{ width: '30%' }}
                                />
                            </div>
                        </div>

                        <div className="row">
                            <Label className="col col-sm-12" obrigatorio>Data da partida</Label>
                            <div className="col-sm-12">
                                <Controller name="dataPartida" control={control} render={({ field }) => (

                                    <DatePicker
                                        inputRef={field.ref}
                                        value={dayjs(viagem.dataPartida)}
                                        onChange={value => {
                                            clearErrors("dataPartida")
                                            setViagem({ ...viagem, dataPartida: value?.toDate() || null })
                                        }}
                                    />
                                )} />
                            </div>
                            {errors.dataPartida && errors.dataPartida.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.dataPartida?.message as string}</span> : null}
                        </div>

                        <div className="row">
                            <Label className="col col-sm-12" obrigatorio>Data do retorno</Label>
                            <div className="col-sm-12">
                                <Controller name="dataRetorno" control={control} render={({ field }) => (

                                    <DatePicker
                                        inputRef={field.ref}
                                        value={dayjs(viagem.dataRetorno)}
                                        onChange={value => {
                                            clearErrors("dataRetorno")
                                            setViagem({ ...viagem, dataRetorno: value?.toDate() || null })
                                        }}
                                    />
                                )} />
                            </div>
                            {errors.dataRetorno && errors.dataRetorno.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.dataRetorno?.message as string}</span> : null}
                        </div>

                        <div className="row">
                            <Label className="col col-sm-12" obrigatorio>Centro de custo</Label>
                            <div className="col-sm-12">
                                <Controller name="centroCusto" control={control} render={({ field }) => (
                                    <Dropdown
                                        focusInputRef={field.ref}
                                        className={errors.atividade ? "p-invalid" : ""}
                                        options={centrosCustoDisponiveis}
                                        optionLabel="nome"
                                        placeholder="Selecione"
                                        value={viagem.centroCusto}
                                        style={{ width: '50%' }}
                                        onChange={(e) => {
                                            clearErrors("centroCusto")
                                            setViagem({ ...viagem, centroCusto: e.value as CentroCusto })
                                        }}
                                    />
                                )} />
                            </div>
                            {errors.centroCusto && errors.centroCusto.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.centroCusto?.message as string}</span> : null}
                        </div>

                        <div className="row">
                            <Label className="col col-sm-12" obrigatorio>Itinerário</Label>
                            <div className="col-sm-12">
                                <InputTextarea
                                    value={viagem.itinerario}
                                    rows={2}
                                    style={{ width: '75%' }}
                                    {...register("itinerario", {
                                        onChange: (e) => {
                                            setViagem({ ...viagem, itinerario: e.target.value as string })
                                            clearErrors("itinerario");
                                        }
                                    })}
                                />
                            </div>
                            {errors.itinerario && errors.itinerario.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.itinerario?.message as string}</span> : null}
                        </div>

                        <div className="row">
                            <Label className="col col-sm-12" obrigatorio>Motivo da viagem</Label>
                            <div className="col-sm-12">
                                <InputTextarea
                                    value={viagem.motivoViagem}
                                    rows={2}
                                    style={{ width: '75%' }}
                                    {...register("motivoViagem", {
                                        onChange: (e) => {
                                            setViagem({ ...viagem, motivoViagem: e.target.value as string })
                                            clearErrors("motivoViagem")
                                        }
                                    })}
                                />
                            </div>
                            {errors.motivoViagem && errors.motivoViagem.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.motivoViagem?.message as string}</span> : null}
                        </div>

                        <div className="row">
                            <Label className="col col-sm-12">Acompanhante</Label>
                            <div className="col-sm-12">
                                <InputTextarea value={viagem.acompanhante} onChange={(e) => setViagem({ ...viagem, acompanhante: e.target.value as string })} rows={2} style={{ width: '75%' }} />
                            </div>
                        </div>

                        <div className="row">
                            <Label className="col col-sm-12" obrigatorio>Tipo de locomoção</Label>
                            <div className="col-sm-12">
                                <Controller name="tipoLocomocao" control={control} render={({ field }) => (
                                    <Dropdown
                                        focusInputRef={field.ref}
                                        className={errors.tipoLocomocao ? "p-invalid" : ""}
                                        options={viagemService.getTiposLocomocao()}
                                        optionLabel="label"
                                        placeholder="Selecione"
                                        value={viagem.tipoLocomocao}
                                        style={{ width: '50%' }}
                                        onChange={(e) => {
                                            clearErrors("tipoLocomocao")
                                            setViagem({ ...viagem, tipoLocomocao: e.value as string })
                                        }}
                                    />
                                )} />
                            </div>
                            {errors.tipoLocomocao && errors.tipoLocomocao.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.tipoLocomocao?.message as string}</span> : null}
                        </div>

                        <div style={{ display: "flex", marginTop: 20 }}>
                            <Checkbox
                                checked={viagem.reservarPassagem}
                                onChange={(e) => { setViagem({ ...viagem, reservarPassagem: e.checked as boolean }) }}
                                style={{ marginRight: 5 }}
                            />
                            <Label className="col col-sm-12">Reservar passagem</Label>
                        </div>

                        {
                            viagem.reservarPassagem ? <div className="row">
                                <Label className="col col-sm-12">Observação da reserva de passagem</Label>
                                <div className="col-sm-12">
                                    <InputTextarea value={viagem.observacaoReservaPassagem} onChange={(e) => setViagem({ ...viagem, observacaoReservaPassagem: e.target.value as string })} rows={2} style={{ width: '75%' }} />
                                </div>
                            </div> : null
                        }

                        <div style={{ display: "flex", marginTop: 20 }}>
                            <Checkbox
                                checked={viagem.reservarHotel}
                                onChange={(e) => { setViagem({ ...viagem, reservarHotel: e.checked as boolean }) }}
                                style={{ marginRight: 5 }}
                            />
                            <Label className="col col-sm-12">Reservar hotel</Label>
                        </div>
                        {
                            viagem.reservarHotel ?
                                <div className="row">
                                    <Label className="col col-sm-12">Observação da reserva de hotel</Label>
                                    <div className="col-sm-12">
                                        <InputTextarea value={viagem.observacaoReservaHotel} onChange={(e) => setViagem({ ...viagem, observacaoReservaHotel: e.target.value as string })} rows={2} style={{ width: '75%' }} />
                                    </div>
                                </div>
                                : null
                        }

                        <div className="row">
                            <Label className="col col-sm-12">Observação da solicitação</Label>
                            <div className="col-sm-12">
                                <InputTextarea value={viagem.observacaoSolicitacao} onChange={(e) => setViagem({ ...viagem, observacaoSolicitacao: e.target.value as string })} rows={2} style={{ width: '75%' }} />
                            </div>
                        </div>

                        <div style={{ display: "flex", marginLeft: -10 }}>
                            <div style={{ flexDirection: "column", marginRight: 20 }}>
                                <Label className="col col-sm-12">Distância prevista (Km)</Label>
                                <div className="col-sm-12">
                                    <InputNumber value={viagem.previsaoQuilometros as number}
                                        onChange={(e) => { setViagem({ ...viagem, previsaoQuilometros: e.value }) }} />
                                </div>
                            </div>
                            <div style={{ flexDirection: "column", marginRight: 20 }}>
                                <Label className="col col-sm-12">Custo por quilomêtro</Label>
                                <div className="col-sm-12">
                                    <InputMonetario value={viagem.custoPorQuilometro as number} disabled onChange={() => { }} />
                                </div>
                            </div>
                            <div style={{ flexDirection: "column", marginRight: 20 }}>
                                <Label className="col col-sm-12">Custo previsto com combustível</Label>
                                <div className="col-sm-12">
                                    <InputMonetario value={(viagem.custoPorQuilometro || 0) * (viagem.previsaoQuilometros || 0)} readOnly onChange={() => { }} />
                                </div>
                            </div>
                        </div>


                        <div className="row">
                            <Label className="col col-sm-12">Valor do adiantamento</Label>
                            <div className="col-sm-12">
                                <InputMonetario value={viagem.valorAdiantamento as number} disabled={adiantamentoIgualDespesaPrevista}
                                    onChange={(e) => { setViagem({ ...viagem, valorAdiantamento: e }) }} />
                            </div>
                        </div>

                        <div className="row">
                            <Label className="col col-sm-12">Data do adiantamento</Label>
                            <div className="col-sm-12">

                                <DatePicker
                                    value={dayjs(viagem.dataAdiantamento)}
                                    onChange={value => {
                                        setViagem({ ...viagem, dataAdiantamento: value?.toDate() || null })
                                    }}
                                />

                            </div>
                        </div>

                        <div style={{ display: "flex", marginTop: 20 }}>
                            <Checkbox style={{ marginRight: 8 }} checked={viagem.depositoConta}
                                onChange={(e) => { setViagem({ ...viagem, depositoConta: e.checked as boolean }) }}
                            />
                            <Label >Depósito em conta</Label>
                        </div>

                        {
                            viagem.depositoConta ?
                                <>
                                    <div className="row">
                                        <Label className="col col-sm-12">Banco do depósito</Label>
                                        <div className="col-sm-12">
                                            <InputText
                                                required value={viagem.bancoDeposito || ""}
                                                onChange={(e) => { setViagem({ ...viagem, bancoDeposito: e.target.value as string }) }}
                                                style={{ width: '30%' }}
                                            />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <Label className="col col-sm-12">Agência do depósito</Label>
                                        <div className="col-sm-12">
                                            <InputText
                                                required value={viagem.agenciaDeposito || ""}
                                                onChange={(e) => { setViagem({ ...viagem, agenciaDeposito: e.target.value as string }) }}
                                                style={{ width: '30%' }}
                                            />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <Label className="col col-sm-12">Conta do depósito</Label>
                                        <div className="col-sm-12">
                                            <InputText
                                                required value={viagem.contaDeposito || ""}
                                                onChange={(e) => { setViagem({ ...viagem, contaDeposito: e.target.value as string }) }}
                                                style={{ width: '30%' }}
                                            />
                                        </div>
                                    </div>
                                </>
                                : null
                        }

                        {true ? null : <div className="row">
                            <Label className="col col-sm-12">Responsável pela autorização</Label>
                            <div className="col-sm-12">
                                <InputText
                                    required value={viagem.usuarioResponsavelAutorizacao?.nome || ""}
                                    style={{ width: '30%' }}
                                />
                            </div>
                        </div>}

                        <div className="row">
                            <Label className="col col-sm-12">Data do acerto</Label>
                            <div className="col-sm-12">
                                <InputText
                                    required value={converterData(viagem.dataAcerto) || ""}
                                    style={{ width: '30%' }}
                                />
                            </div>
                        </div>

                        <div className="row">
                            <Label className="col col-sm-12 mb-2 mt-2">Aprovações</Label>
                            <Accordion multiple >
                                {aprovacoesAgrupadas.map(grupo => {
                                    return <AccordionTab key={grupo.sequencial} header={"Sequencial: " + grupo.sequencial}>
                                        <DataTable value={grupo.aprovacoes} header='Aprovações' emptyMessage="Nenhum registro encontrado">
                                            <Column field="usuario.nome" header="Aprovador" />
                                            <Column field="situacao" header="Situação" body={(rowData) => viagemAprovacaoService.getSituacaoAprovacao(rowData.situacao)} />
                                            <Column field="dataAprovacao" header="Data da situação" body={(rowData) => converterData(rowData.dataAprovacao)} />
                                            <Column field="motivo" header="Motivo da rejeição" />
                                        </DataTable>
                                    </AccordionTab>
                                })}
                            </Accordion>
                        </div>
                    </TabPanel>
                    <TabPanel header="Despesas Previstas">
                        <div className="row" style={{ marginTop: '20px' }}>
                            <div className="col-sm-12">
                                <DataTable
                                    dataKey="id" value={viagem.despesasPrevistas ?? []}
                                    scrollable scrollHeight="500px"
                                    header={headerDespesaPrevista}
                                    footer={footerDespesasPrevistas}
                                    emptyMessage="Nenhum registro encontrado"
                                >
                                    <Column field="tipo.nome" header="Tipo" />
                                    <Column field="formaPagamento" header="Forma de pagamento" body={(rowData) => viagemDespesaPrevistaService.getFormaPagamento(rowData.formaPagamento)} style={{ width: '200px' }} />
                                    <Column field="observacao" header="Observação" style={{ width: '30%' }} />
                                    <Column field="valor" header="Valor" body={(rowData) => rowData.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} style={{ width: '150px' }} />
                                    <Column header="Ações" style={{ width: '120px' }}
                                        body={(rowData, { rowIndex }) => (
                                            <>
                                                <Button icon={<FontAwesomeIcon icon="edit" />} onClick={() => setDialogDespesaPrevista({ visible: true, despesa: rowData })} />
                                                {viagemDespesaPrevistaService.podeAlterar(viagem.situacao) ? <Button type="button" icon={<FontAwesomeIcon icon="remove" />} className="ui-button-danger" style={{ marginLeft: 8 }} onClick={() => removerDespesaPrevista(rowData)}></Button> : null}
                                                {rowData.imagens.length > 0 ? <Button icon="pi pi-images" style={{ marginLeft: 8 }} onClick={() => setDialogImagensDespesaPrevista({ visible: true, despesaPrevista: rowData, index: rowIndex })} /> : null}
                                            </>
                                        )} />
                                </DataTable>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel header="Despesas">
                        <div className="row" style={{ marginTop: '20px' }}>
                            <div className="col-sm-12">
                                <DataTable
                                    value={viagem.despesas ?? []}
                                    header={headerDespesa}
                                    footer={footerDespesas}
                                    emptyMessage="Nenhum registro encontrado"
                                    expandedRows={expandedRowsDespesas}
                                    rowExpansionTemplate={rowExpansionTemplateDespesas}
                                    onRowToggle={(e) => setExpandedRowsDespesas(e.data)}
                                >
                                    <Column expander={(rowData) => rowData.aprovacoes && rowData.aprovacoes.length > 0} style={{ width: '3em' }} />
                                    <Column field="tipo.nome" header="Tipo" />
                                    <Column field="dataDespesa" header="Data da despesa" body={(rowData) => converterData(rowData.dataDespesa)} />
                                    <Column field="observacao" header="Observação" />
                                    <Column field="valor" header="Valor" body={(rowData) => rowData.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} />
                                    <Column field="situacao" header="Situação" body={(rowData) => viagemDespesaService.getSituacao(rowData.situacao)} />
                                    <Column header="Ações"
                                        body={(rowData) => (
                                            <>
                                                <Button icon={<FontAwesomeIcon icon="edit" />} onClick={() => setDialogDespesa({ visible: true, despesa: rowData })} />
                                                {excluiDespesas && viagem.situacao != 'FINALIZADA' && viagem.situacao != 'CANCELADA' ? <Button type="button" icon={<FontAwesomeIcon icon="remove" />} className="ui-button-danger" style={{ marginLeft: 8 }} onClick={() => removerDespesa(rowData)}></Button> : null}
                                                {rowData.imagens.length > 0 ? <Button icon="pi pi-images" style={{ marginLeft: 8 }} onClick={() => setDialogImagens({ visible: true, despesa: rowData, index: rowData.rowIndex })} /> : null}
                                            </>
                                        )} />
                                </DataTable>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel header="Valor previsto por forma de pagamento">
                        <div className="row" style={{ marginTop: '20px' }}>
                            <div className="col-sm-12">
                                <DataTable
                                    value={(viagem.despesasPrevistas ?? []).reduce((acc, item) => {
                                        let valor = item.valor || 0;
                                        let index = acc.findIndex(i => i.formaPagamento === item.formaPagamento);
                                        if (index === -1) {
                                            acc.push({ formaPagamento: item.formaPagamento, valor });
                                        } else {
                                            acc[index].valor += valor;
                                        }
                                        return acc;
                                    }, [] as { formaPagamento: string | null, valor: number }[])}
                                    header={"Valor previsto por forma de pagamento"}
                                    footer={footerDespesasPrevistas}
                                    emptyMessage="Nenhum registro encontrado"
                                >
                                    <Column field="formaPagamento" header="Forma de pagamento" body={(rowData) => viagemDespesaPrevistaService.getFormaPagamento(rowData.formaPagamento)} style={{ width: '200px' }} />
                                    <Column field="valor" header="Valor" body={(rowData) => rowData.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} style={{ width: '25%' }} />
                                </DataTable>
                            </div>
                        </div>
                    </TabPanel>
                </TabView >
            </BaseCadastro >
        </>
    )
}
